<template>
<span class="spinelab-website-front">
  <v-navigation-drawer permanent app :mini-variant="mini">
    <v-list>
      <v-list-tile>
        <v-list-tile-content v-if="!mini" />
        <v-list-tile-action>
          <v-btn icon @click.native.stop="mini = !mini">
            <v-icon>{{ mini ? 'chevron_right' : 'chevron_left' }}</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider v-if="!mini" />
    <v-list v-if="!mini">
      <v-list-tile v-for="item in items"
                   :key="item.path"
                   @click="clicked(item)"
                   v-if="item.meta.requiresSuperuser === false ||
                   (item.meta.requiresSuperuser === true && getRole() === 'superuser')">
        <v-list-tile-content>
          <v-list-tile-title>{{item.name}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
  <router-view v-if="initiated" />
</span>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

const items = [
  { path: 'users', name: 'ユーザ管理', meta: { requiresSuperuser: false } },
  { path: 'contacts-csv', name: 'お問合せ一括管理', meta: { requiresSuperuser: false } },
  { path: 'admin-users', name: 'アドミンユーザ管理', meta: { requiresSuperuser: true } },
  { path: 'site-list', name: '会員別利用状況', meta: { requiresSuperuser: true } },
  { path: '/admin-login', name: 'ログアウト', meta: { requiresSuperuser: false } },
];

export default {
  name: 'Admin',
  data() {
    return {
      initiated: false,
      mini: false,
      loading: false,
      items,
    };
  },
  methods: {
    ...mapActions(['adminLogout', 'showAlert', 'setAdminRole']),
    ...mapGetters(['getRole']),
    async clicked(item) {
      if (item.path === '/admin-login') {
        await this.adminLogout();
      }
      this.$router.push(item.path);
    },
    async loadRole() {
      this.loading = true;
      const role = await this.setAdminRole();
      this.loading = false;
      return role;
    },
  },
  async created() {
    await this.loadRole();
    this.initiated = true;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/admin/Admin.vue